// Вкладки хаба новостей (гид §2.9, «восемь предложений» п.2): tab_bar ответа screens/cricket/news/hub/.
// main — сам хаб (данные в этом ответе), videos — экран видео (endpoint как есть), topic:<slug> — лента темы
// (endpoint = feed_path темы). Незнакомый ключ, тема без адреса, дубль — молча мимо. Старый ответ без tab_bar —
// своё: «Главное», «Видео» и быстрые темы (quick_topics).
import type { NewsHub } from '../../api/leagueTypes';
import { t } from '../../i18n/i18n';

export type NewsTab =
  | { kind: 'main'; key: string; label: string }
  | { kind: 'videos'; key: string; label: string; endpoint?: string }
  | { kind: 'topic'; key: string; label: string; endpoint: string };

export const NEWS_MAIN = 'main';

export function newsTabs(hub: Pick<NewsHub, 'tab_bar' | 'quick_topics'>): NewsTab[] {
  const seen = new Set<string>();
  const tabs: NewsTab[] = [];
  for (const item of hub.tab_bar?.items ?? []) {
    if (!item?.key || seen.has(item.key)) continue;
    const tab = parse(item.key, item.label, item.endpoint);
    if (tab) { seen.add(item.key); tabs.push(tab); }
  }
  if (tabs.some((x) => x.kind === 'main')) return tabs;
  // Без «Главного» хабу показать нечего из этого ответа — значит, tab_bar нет (или он нам незнаком): своё.
  return [
    { kind: 'main', key: NEWS_MAIN, label: t('tg_news_main') },
    { kind: 'videos', key: 'videos', label: t('mc_videos') },
    ...(hub.quick_topics ?? []).map((x): NewsTab => ({ kind: 'topic', key: `topic:${x.slug}`, label: x.short_name ?? x.name, endpoint: x.feed_path })),
  ];
}

function parse(key: string, label: string | undefined, endpoint: string | null | undefined): NewsTab | null {
  if (key === NEWS_MAIN) return { kind: 'main', key, label: label || t('tg_news_main') };
  if (key === 'videos') return { kind: 'videos', key, label: label || t('mc_videos'), endpoint: endpoint ?? undefined };
  if (key.startsWith('topic:') && endpoint) return { kind: 'topic', key, label: label || key.slice('topic:'.length), endpoint };
  return null;
}

/** Активная: выбранная человеком, пока сервер её не убрал; иначе default_key; иначе первая. */
export function activeNewsTab(tabs: NewsTab[], defaultKey: string | undefined, chosen: string | null): string {
  if (chosen && tabs.some((x) => x.key === chosen)) return chosen;
  return tabs.find((x) => x.key === defaultKey)?.key ?? tabs[0]!.key;
}

/** Статья новости (/news/:id) — экран без нижней панели приложения (Figma 772:32587; прячет Shell). */
export function isArticlePath(pathname: string): boolean {
  return /^\/news\/[^/]+\/?$/.test(pathname);
}
